import store from '@/app/store/store';
import HELPER from '@/app/utils/HELPER';
import fuzzySearch from '@/app/utils/gfFuzzySearch.ts';
const elementsStore = store.getValue('__myElements');
export const keyCurrentSidebarTab = '__currentSidebarTab';
import { keyCurrentSettingTab } from '@/app/editor/sidebar/gfTabs';
import { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import { addBlockedScript } from '@/app/utils/helpers.ts';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { LIBRARY_MODAL_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { debounce } from '@modules/common';
import emitter from '@/emitter';

function sortCategoriesScore(array, sort = 'DESC') {
  for (let i = 0; i < array.length; i++) {
    for (let j = array.length - 1; j > i; j--) {
      if (Object.values(array[i])[0] < Object.values(array[j])[0]) {
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
    }
  }
  return array;
}

function addTrackingSearchElementByKeyword(keyword, numberOfResult) {
  if (keyword) {
    const shopInfo = app.$store.state['app'].shopInfo;
    app.$store.dispatch('common/trackEvent', { 
      eventId: LIBRARY_MODAL_EVENT.SEARCH_ELEMENT_ON_SIDEBAR,
      properties: {
        search_keywords: keyword,
        number_of_result_found: numberOfResult,
        shop_created_at: shopInfo.createdAt,
        shop_plan: shopInfo.plan
      }
    });
  }
}

/* ------------------------------------------ GRYFF LEFT SIDEBAR - CHRIS 03.08.2016 ----------------------------------------- */
(function (jQuery) {
  const $vectors = {
    toggle: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9219 9.94824L12.2319 14.6378V14.6378C12.104 14.7659 11.8965 14.766 11.7685 14.6381C11.7683 14.638 11.7682 14.6379 11.7681 14.6378L7.07812 9.94824" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    info: `<svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.42578 5.25V4.07422H7.57422V5.25H6.42578ZM3.69141 10.3086C4.62109 11.2201 5.72396 11.6758 7 11.6758C8.27604 11.6758 9.36979 11.2201 10.2812 10.3086C11.2109 9.37891 11.6758 8.27604 11.6758 7C11.6758 5.72396 11.2109 4.63021 10.2812 3.71875C9.36979 2.78906 8.27604 2.32422 7 2.32422C5.72396 2.32422 4.62109 2.78906 3.69141 3.71875C2.77995 4.63021 2.32422 5.72396 2.32422 7C2.32422 8.27604 2.77995 9.37891 3.69141 10.3086ZM2.87109 2.89844C4.01953 1.75 5.39583 1.17578 7 1.17578C8.60417 1.17578 9.97135 1.75 11.1016 2.89844C12.25 4.02865 12.8242 5.39583 12.8242 7C12.8242 8.60417 12.25 9.98047 11.1016 11.1289C9.97135 12.2591 8.60417 12.8242 7 12.8242C5.39583 12.8242 4.01953 12.2591 2.87109 11.1289C1.74089 9.98047 1.17578 8.60417 1.17578 7C1.17578 5.39583 1.74089 4.02865 2.87109 2.89844ZM6.42578 9.92578V6.42578H7.57422V9.92578H6.42578Z" fill="currentColor"/></svg>`,
    add: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 23V7H15.5V23H14.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 15.5L7 15.5L7 14.5L23 14.5L23 15.5Z" fill="currentColor"/></svg>`,
  };

  function _scrollIntoElement(child = '.snippet-wrap .snippet.isNew', delay = 1000, duration = 1000) {
    // Consider remove this function
    setTimeout(function () {
      const $el = $('.all-snippets').parent();
      const $child = $(child);

      if ($child.length) {
        const currentTop = $('.all-snippets').parent().scrollTop();
        const change = $child.offset().top - $child.height() * 2;

        $el.animate(
          {
            scrollTop: currentTop + change,
          },
          duration,
        );
      }
    }, delay);
  }

  jQuery.gfLeftSideBar = function (element, options) {
    function _generateTriggerButton() {
      const svg = $vectors['toggle'];
      return `<span class="gf-sperator-element_toggler">${svg}</span>`;
    }

    const defaults = {};
    this.settings = {};
    this.categoriesOrder = {};

    const $element = jQuery(element);
    const $divTopBar = getGlobalVariable('divTopBar');
    const _this = this;

    let $sideTools;
    let $sidePanels;
    let cacheSearchKeyword = "";

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');

    /* Iframe */
    let $gfFrame = getGlobalVariable('gfFrame');
    let $gfFrameWrap = jQuery('#gfFrameWrap');
    let $gryffEditor = getGlobalVariable('gryffEditor');
    let $gryffBody = getGlobalVariable('gryffBody');

    // var snippetUsage = [];

    this.$vectors = $vectors;

    this.renderElements = renderElements;
    this.storeElement = storeElement;
    this.removeElement = removeElement;
    this.scrollIntoElement = _scrollIntoElement;
    this.snippetUsage = {};

    this.refreshGlobalVariable = function(){
      $gfFrame = getGlobalVariable('gfFrame');
      $gfFrameWrap = jQuery('#gfFrameWrap');
      $gryffEditor = getGlobalVariable('gryffEditor');
      $gryffBody = getGlobalVariable('gryffBody');
    }

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $sideTools = $element.find('.side-tools');
      $sidePanels = $element.find('.side-panels');

      /* wrap resize */
      const setSize = function () {
        if (jQuery(window).width() <= 1300) {
          // var sideWidth = 260;
          $element.addClass('side-sm');
        } else {
          $element.removeClass('side-sm');
          // var sideWidth = 290;
        }
        const sideWidth = $gfLeftSideBar.width();
        const wrapSize = jQuery(window).width() - sideWidth + 1; // Add 1px for round offset
        $gfFrameWrap.attr('data-width', wrapSize).css('width', wrapSize);
      };
      setSize();

      jQuery(window).on('resize', function () {
        setSize();
      });
      _this.createButtonCookie();
      _this.setupCategoriesOrder();
      return false;
    };

    // TODO: DUKCY loadSnippets
    this.loadSnippets = function (callback) {
      const callBackSnippets = function (data) {
        const $panel = $sidePanels.find('#md-snippets');
        const snippets = '',
          elements = '',
          modules = '',
          cats = '';
        const $data = jQuery('<div/>').html(data);

        $data.children('.gryff').each(function () {
          storeElement(this);
        });

        renderElements(function () {
          // DO NOTHING
          // TODO: DUKCY callback init module
          // callback();
        });

        return false;
      };

      const snippets = store.getValue('__snippets');

      if (snippets) {
        callBackSnippets(snippets);
      } else {
        store.onChange('__snippets', (snippets) => {
          callBackSnippets(snippets);
        });
      }

      return false;
    };

    this.offAllBackgroundIframe = function () {
      var $backgrounds = $gryffBody.find('.gfSideBarOverlay');
      if ($backgrounds.length > 0) {
        for (var i = 0; i < $backgrounds.length; i++) {
          var $background = $($backgrounds[i]);
          if ($background.hasClass('show')) {
            $background.trigger('mousedown.removeBackground');
            $background.removeClass('show');
          }
        }
      }
      var $backgrounds = $gfFrameWrap.find('.gfSideBarOverlay');
      if ($backgrounds.length > 0) {
        for (var i = 0; i < $backgrounds.length; i++) {
          var $background = $($backgrounds[i]);
          if ($background.hasClass('show')) {
            $background.trigger('mousedown.removeBackground');
            $background.removeClass('show');
          }
        }
      }
      return false;
    };

    this.onBackgroundIframe = function (className, outside) {
      if (className == undefined) {
        className = '';
        return false;
      }
      let $target = $gryffBody.find('.' + className);
      if (outside) {
        $target = $gfFrameWrap.find('.' + className);
      }
      if ($target.length == 0) {
        setTimeout(function () {
          if (outside) {
            $gfFrameWrap.append('<div class="gfSideBarOverlay ' + className + ' show"></div>');
          } else {
            $gryffBody.append('<div class="gfSideBarOverlay ' + className + ' show"></div>');
          }
        }, 0);
      } else {
        setTimeout(function () {
          $target.addClass('show');
        }, 0);
      }
    };

    this.offBackgroundIframe = function (className, outside) {
      if (className == undefined) {
        className = '';
        return false;
      }
      setTimeout(function () {
        if (outside) {
          $gfFrameWrap.find('.' + className).removeClass('show');
        } else {
          $gryffBody.find('.' + className).removeClass('show');
        }
      }, 0);
    };

    this.searchSnippets = function (txt, searchType) {
      const s = txt.trim().replace(/\s+/g, ' ').toLowerCase();
      const $allSnippets = $element.find('.all-snippets');

      $element.find('.gf-sperator-element').removeClass('hide');
      $sidePanels.find('.gf-sperator-element');
      $element.find('.gf-sperator-element').each(function (index, item) {
        const $item = $(item);
        const $toggler = $item.children('.gf-sperator-element_toggler');
        if (!$toggler) return;
        const show = $toggler.attr('data-show');
        if (show == false || show == 'false') {
          $item.trigger('click.toggle');
        }
      });
      const addmore =
        `<div class="snippet-wrap show" id="gfAddSnippetButton">` +
        `<div class="snippet snippet-addmore hover">` +
        `<div class="snippet-icon">${$vectors.add}</div>` +
        `<span class="snippet-label">Add Elements</span>` +
        `</div>` +
        `</div>`;
      const $emptyBlock = $(`<div class="gf_empty-search-element">
              Hmm, nothing here...<br>Can you try another keyword?
              <div class="gf_empty-search-add">
                <p>Or you can find it in Library</p>
                ${addmore}
              </div>
            </div>`);
      $allSnippets.find('.gf_empty-search-element').remove();
      if (s == '') {
        $element.find('.all-snippets .snippet-wrap').addClass('show');

        // // Reset order css
        $allSnippets.find(".gf-snippet-category").not(".gf-snippet-category--no-order").css("order", "");

        renderElements();
      } else {
        const cats = [];
        let foundCount = 0;

        // The array of category with highest score
        // Eg: [{base: 0.7}, {module: 0.5}]
        const catsScore = [];

        $element
          .find('.all-snippets .snippet-wrap')
          .not('#gfAddSnippetButton')
          .removeClass('show')
          .each(function () {
            const $snippet = jQuery(this).children('.snippet');

            // Check if element is not "More Elements" button

            if (jQuery(this).attr('id') != 'gfAddSnippetButton') {
              const label = $snippet.find('.snippet-label').text().trim().replace(/\s+/g, ' ').toLowerCase();
              const des = $snippet.find('.snippet-desc').text().trim().replace(/\s+/g, ' ').toLowerCase();
              const cat = $snippet.attr('data-cat') || '';

              // Init Fuzzy Search for label
              const fsLabel = fuzzySearch();
              // Init Fuzzy Search for desc
              const fsDesc = fuzzySearch();

              // Add label to fs
              fsLabel.add(label);

              // Split desc and add to desc fs
              des.split(',').forEach((e) => {
                if (e.trim()) {
                  fsDesc.add(e.trim());
                }
              });

              // Label fs result
              const resultLabel = fsLabel.get(s);
              // Desc fs result
              const resultDesc = fsDesc.get(s);

              let found = false;

              /**
               * Check match
               * Score range 0-1
               * Label: score > 0.5
               * Desc: score > 0.6
               * If index of keyword is positive, score is 1
               */
              if (resultLabel || resultDesc) {
                resultLabel?.forEach((e) => {
                  if (e[0] >= 0.5) {
                    found = true;
                  }
                });

                resultDesc?.forEach((e) => {
                  if (e[0] >= 0.6) {
                    found = true;
                  }
                });

                if (label.indexOf(s) > -1 || des.indexOf(s) > -1) {
                  found = true;
                }

                if (found) {
                  jQuery(this).addClass('show');
                  foundCount++;

                  cats.push(cat);

                  const maxScore = HELPER.findMaxNumberInArray([...resultLabel, ...resultDesc].map((e) => e[0]));

                  const catTransform = HELPER.transformCategory(cat);
                  const catFound = HELPER.findObjectInArrayByKey(catTransform, catsScore);
                  if (catFound) {
                    const currentScore = catFound[catTransform];
                    if (currentScore < maxScore) {
                      const obj = {
                        key: catTransform,
                        value: maxScore,
                      };
                      HELPER.updateValueInArrayByKey(obj, catsScore);
                    }
                  } else {
                    const obj = {};
                    obj[catTransform] = maxScore;
                    catsScore.push(obj);
                  }
                }
              }
            }
          });

        sortCategoriesScore(catsScore);
        for (let i = 0; i < catsScore.length; i++) {
          $allSnippets.find(`.gf-snippet-category[data-cat=${Object.keys(catsScore[i])[0]}]`).css('order', i);
        }

        // Add text to notify if there's no item match search.
        if (foundCount == 0) {
          $element.find('#gfAddSnippetButton').removeClass('show');
          $allSnippets.append($emptyBlock);
          this.addEventForAddMoreSnippet()
        }

        // Hide category name if category has no item that match search.;
        $element.find('.all-snippets .gf-sperator-element').each(function () {
          const $separator = $(this);
          if (foundCount != 0 && $separator.hasClass('gf-other_elements')) {
            return false;
          }
          const $list = $separator.next();
          const countShow = $list.find('.snippet-wrap.show').length;
          if (countShow == 0) {
            $separator.addClass('hide');
          } else {
            $separator.children('.gf-sperator-element_toggler').removeClass('closed');
            $separator.next('.gf_snippets-list').show();
          }
        });

        setTimeout(function () {
          _this.applyEvents();
        }, 10);

        $element.find('.gf-sperator-element').each(function () {
          const $separator = jQuery(this);
          const text = $separator.text().trim();
          if (jQuery.inArray(text, cats) === -1) {
            // $separator.addClass('hide');
          }
        });

        debounce(() => {
          if (txt !== cacheSearchKeyword) {
            const numberOfResult = $element.find('.all-snippets .snippet-wrap.show').not('#gfAddSnippetButton').length;
            addTrackingSearchElementByKeyword(txt, numberOfResult)
            cacheSearchKeyword = txt;
          }
        }, 1000)();
      }

      // bind events
      $element
        .find('.btnCancel')
        .off()
        .on('click', function (e) {
          _this.toggleTabPanels();
          return false;
        });

      return false;
    };

    this.gotoTab = function (index) {
      $sideTools.children('ul').children('li').removeClass('active');
      $sideTools.children('ul').children('li').eq(index).addClass('active');

      $sidePanels.children('.side-panel').removeClass('active');

      const $sidePanel = $sidePanels.children('.side-panel').eq(index);
      $sidePanel.addClass('active');

      //Close background gfFrameWrap;
      $gfLeftSideBar.data('gfleftsidebar').offAllBackgroundIframe();

      //add store current tab
      store.setValue(keyCurrentSidebarTab, index);

      const $mdSnippets = $gfLeftSideBar.find('#md-snippets');
      let isOpenSetting = true;
      if ($mdSnippets.hasClass('active')) {
        isOpenSetting = false;
      }

      app.$store.commit('sidebar/SET_IS_OPEN_SETTING', isOpenSetting);
      emitter.emit('gemmeter:close-droplist');
      return false;
    };

    this.applyDragForASnippet = function (context) {
      const $snippet = jQuery(context);
      const snipDataKey = $snippet.attr('data-key');
      $snippet.not('.isTest').gfDraggable({
        type: 'snippet',
        stop: function (nearY) {
          const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY'](snipDataKey);
          app.$store.state.app.usedToDragDrop = true;
          const $snippetStore = jQuery(storeSnippet);

          let label;
          if (nearY) {
            const $newPlace = window.$gfPlaceHolders.eq(nearY.id);
            if ($newPlace.length === 1) {
              label = $snippetStore.attr('data-label');
              // Add to gfCount
              const extraCount = {
                label: label,
              };

              if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                $gryffEditor.data('gfcount').add('drag-snippet', extraCount);
              }

              if ($snippetStore.find('.libs').length > 0) {
                try {
                  let json;
                  let libJson;
                  try {
                    json = jQuery.parseHTML($snippetStore.find('.libs').html())[0];
                    libJson = jQuery.parseJSON($snippetStore.find('.libs').html());
                    if (json) json = json.textContent.trim();
                  } catch (e) {
                    json = `{ "libs": [] }`;
                  }
                  libJson = JSON.parse(json);

                  const libs = [];
                  const libJsonLength = libJson['libs'].length;
                  for (let i = 0; i < libJsonLength; i++) {
                    if (jQuery.inArray(libJson['libs'][i], window._pageLibs) === -1) {
                      libs.push(libJson['libs'][i]);
                    }
                  }
                  const $loading = jQuery('<div class="module-loading"></div>');
                  HELPER.getLibs({
                    urls: libs,
                    start: function () {
                      $newPlace.before($loading);
                      _this.showLoading($loading);
                    },
                    done: function () {
                      const libsLength = libs.length;
                      for (let i = 0; i < libsLength; i++) {
                        if (jQuery.inArray(libs[i], window._pageLibs) === -1) {
                          window._pageLibs.push(libs[i]);
                        }
                      }
                      setTimeout(function () {
                        HELPER.initMERfromSnippet($snippetStore, $loading);
                        _this.hideLoading($loading);
                      }, 300);
                    },
                    error: function () {
                      HELPER.showNotify('There are some errors occurred please try again.', 'error');
                      _this.hideLoading($loading);
                    },
                    block: function () {
                      /**
                       * trường hợp bị cookieyes chặn
                       * Vẫn done như bình thường và gắn cờ bị block js
                       */
                      const libsLength = libs.length;
                      for (let i = 0; i < libsLength; i++) {
                        addBlockedScript(libs[i]);
                      }
                      this.done();
                    },
                  });
                } catch (err) {
                  console.log(err.message);
                  HELPER.showNotify('There are some errors occurred please try again.', 'error');
                }
              } else {
                HELPER.initMERfromSnippet($snippetStore, $newPlace);
              }
            }
          }

          if ($snippetStore.hasClass('isNew')) {
            // MARK AS USED
            const cat = $snippetStore.attr('data-cat');
            const id = $snippetStore.attr('data-id');
            $snippetStore.removeClass('isNew');
            if (elementsStore && Object.keys(elementsStore).length != 0) {
              const index = elementsStore[cat].findIndex((item) => {
                const _$item = $(item);
                const _label = _$item.attr('data-label');
                const _id = _$item.attr('data-id');
                return id == _id && label == _label;
              });
  
              if (index > -1) {
                $(elementsStore[cat][index]).removeAttr('data-status');
              }
            }
          }
          // Collect usage information
          const snippetId = parseInt($snippetStore.attr('data-id'));
          const snippetKey = $snippetStore.attr('data-key');
          if (snippetId != NaN && snippetKey != undefined && snippetKey != '') {
            _this.incSnippetUsage(snippetId, snippetKey);
          }
        },
      });
    };

    this.applySnippetDrag = function () {
      $sidePanels.off('mouseenter', '.all-snippets').on('mouseenter', '.all-snippets', function () {
        $gryffEditor = getGlobalVariable('gryffEditor');
        $gryffEditor.trigger('drag-active');
      });
      return false;
    };

    this.addEventForAddMoreSnippet = function () {
      const $addSnippetButton = $sidePanels.find('#gfAddSnippetButton .snippet');
      $addSnippetButton.off('mousedown mouseup').on('mousedown mouseup', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
      $addSnippetButton.off('click').on('click', function () {
        app.$store.commit(`library/${mutations.TOGGLE}`, true);
        app.$store.commit(`library/${mutations.CHANGE_LAYOUT}`, 'default');
        app.$store.commit(`library/${mutations.CHANGE_TAB}`, 'elements');
        return false;
      });
    };

    this.applyEvents = function () {
      _this.applySnippetDrag();
      $sidePanels.find('.snippet').each(function (index, snippet) {
        const $snippet = $(snippet);

        const $template = $($snippet.find('script.template'));

        const $info = $($snippet.find('.snippet-info'));
        $info.off('mousedown mouseup').on('mousedown mouseup', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
        $info.off('click.view').on('click.view', function (e) {
          // e.preventDefault();
          // e.stopPropagation();
          // var $item = $(item);
          const id = $snippet.attr('data-id');
          app.$store.commit(`library/${mutations.CHANGE_TAB}`, 'elements');
          app.$store.commit(`library/${mutations.OPEN_ELEMENT_DETAIL}`, id);

          return false;
        });
      });

      // Add event listener for toggle close/open elements/blocks lists
      $sidePanels.find('.gf-sperator-element').each(function (index, item) {
        $(item)
          .off('click.toggle')
          .on('click.toggle', function () {
            const $item = $(item);
            const $child = $item.find('.gf-sperator-element_toggler');
            const show = !($child.attr('data-show') == 'true');

            if ($child.length > 0) {
              $child.toggleClass('closed');
            } else {
              $item.append(_generateTriggerButton());
            }

            $item.next().slideToggle('fast');
          });
      });
      const __searchTracker = {
        timeout: null,
        oldSearch: '',
      };
      $sidePanels
        .find('#md-snippets .gfModalFilter input[type=text]')
        .off('focus')
        .on('focus', function () {
          const $parent = $(this).parent();
          if (!$parent.hasClass('isFocusing')) {
            $parent.addClass('isFocusing');
          }
        })
        .off('blur')
        .on('blur', function () {
          const $parent = $(this).parent();
          if ($parent.hasClass('isFocusing')) {
            $parent.removeClass('isFocusing');
          }
        })
        .off('mousedown')
        .on('mousedown', function () {
          $gfLeftSideBar.data('gfleftsidebar').showHighlighter('focus-input');
        })
        .off('change keyup')
        .on('change keyup', function () {
          const $that = jQuery(this);
          const txt = $that.val().trim().replace(/\s+/g, ' ').toLowerCase();
          if (txt) {
            $that
              .siblings('.modal-search')
              .html(
                '<i><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.875 10.125L10.125 3.875" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.875 3.875L10.125 10.125" stroke-linecap="round" stroke-linejoin="round"/></svg></i>',
              );
            $that
              .siblings('.modal-search')
              .find('*')
              .off('mousedown.clearSearch')
              .on('mousedown.clearSearch', function () {
                $that.val('').change();
              });
          } else {
            $that
              .siblings('.modal-search')
              .html(
                '<i><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><g><path d="M7.42622 2.19258C9.48552 3.02355 10.4813 5.36658 9.65032 7.42588C8.81935 9.48519 6.47632 10.481 4.41702 9.64998C2.35771 8.81901 1.36195 6.47598 2.19292 4.41668C3.02388 2.35738 5.36692 1.36161 7.42622 2.19258" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16016 9.16016L12.3521 12.3521" stroke-linecap="round" stroke-linejoin="round"/></g></svg></i>',
              );
          }
          const type = $sidePanels.find('#md-snippets .gfSelectedSCat').text().trim();
          _this.searchSnippets(txt, type);

          return false;
        });

      // close settings
      $gfFrameWrap.off('mousedown.close').on('mousedown.close', function (e) {
        if (e.which != 3) {
          // save last scroll location
          // var highlightCounter

          // Kiểm tra có màng bao phủ không;
          const $overlays = $gryffBody.find('.gfSideBarOverlay');
          if ($overlays.length > 0) {
            let count = 0;
            let advanced = false;
            for (let i = 0; i < $overlays.length; i++) {
              const $overlay = $($overlays[i]);
              if ($overlay.hasClass('show') && !$overlay.hasClass('backgroundAdv')) {
                $overlay.trigger('mousedown');
                count++;
              }
              if ($overlay.hasClass('backgroundAdv')) {
                advanced = true;
              }
            }
            if (count == 0) {
              if (advanced == true) {
                $gryffBody.find('.gfSideBarOverlay.backgroundAdv').trigger('mousedown');
              } else {
                // Close settings
                var $target = jQuery(e.target);
                if ($target.closest('.gf_row, .module-wrap, .element-wrap').length == 0) {
                  setTimeout(function () {
                    _this.gotoTab(0);

                    // Add to gfCount
                    const extraCount = {};
                    if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                      $gryffEditor.data('gfcount').add('back-to-snippets-iframe', extraCount);
                    }
                  }, 0);
                }
              }
            }
          } else {
            // Close settings
            var $target = jQuery(e.target);
            if ($target.closest('.gf_row, .module-wrap, .element-wrap').length == 0) {
              setTimeout(function () {
                _this.gotoTab(0);

                // Add to gfCount
                const extraCount = {};
                if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                  $gryffEditor.data('gfcount').add('back-to-snippets-iframe', extraCount);
                }
              }, 0);
            }
          }
        }
      });

      $gryffBody.off('mousedown.close').on('mousedown.close', function (e) {
        if (e.which != 3) {
          const $target = jQuery(e.target);
          // Kiểm tra có phải bấm vào màng bao phủ không;
          if ($target.closest('.gfSideBarOverlay').length == 0) {
            // Close settings
            if ($target.closest('.gf_row, .module-wrap, .element-wrap').length == 0) {
              setTimeout(function () {
                _this.gotoTab(0);

                // Add to gfCount
                const extraCount = {};
                if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                  $gryffEditor.data('gfcount').add('back-to-snippets-gryffBody', extraCount);
                }
              }, 0);
            }
          }
        }
      });

      // For gfOutline event
      $gfLeftSideBar.on('mouseup.outline', function (e) {
        $gryffBody.trigger('mouseup.outline');
      });

      // For gfOutline event
      $divTopBar.on('mouseup.outline', function (e) {
        $gryffBody.trigger('mouseup.outline');
      });

      // For gfOutline event
      $gfLeftSideBar.off('mouseleave.mp').on('mouseleave.mp', function () {
        $gfFrame = getGlobalVariable('gfFrame');
        $gfFrameWrap = jQuery('#gfFrameWrap');
        $gryffEditor = getGlobalVariable('gryffEditor');
        $gryffBody = getGlobalVariable('gryffBody');
        if (!$gryffEditor.data('gryffeditor').isDragging()) {
          clearTimeout(window._gTimeOut);

          const $mdSetting = jQuery('#md-settings');
          const $targetElement = _this.getTargetElement();
          const $gfPadding = $mdSetting.find('.gf_padding');
          const $gfMargin = $mdSetting.find('.gf_margin');
          const $gfOutline = $targetElement.data('gfoutline');

          if (!$gfOutline) {
            return;
          }

          if ($gfPadding) {
            $gfOutline.hidePadding();
          } else if ($gfMargin) {
            $gfOutline.hideMargin();
          }
        }
      });

      // for gfMarginPadding event
      $gfLeftSideBar.on('init.mousemove.mp', function (evt, data) {
        _this.initMouseMoveEvent(data);
      });

      // for gfMarginPadding event
      $gfLeftSideBar.on('init.mouseup.mp', function (evt, data) {
        _this.initMouseUpEvent(data);
      });

      return false;
    };

    this.initMouseUpEvent = function (data) {
      const { $that, $element, $gfInputField, $targetElement } = data;
      $gfLeftSideBar.off('mouseup.mp').on('mouseup.mp', function (e) {
        $gfInputField.find('input').removeClass('scrolling');

        $gfLeftSideBar.css('cursor', 'default').off('mouseup.mp');
        $gfLeftSideBar.css('cursor', 'default').off('mousemove.mp');

        if ($element.hasClass('gf_padding') && $targetElement.data('gfoutline') != undefined) {
          $targetElement.data('gfoutline').hidePadding();
        } else if ($element.hasClass('gf_margin') && $targetElement.data('gfoutline') != undefined) {
          $targetElement.data('gfoutline').hideMargin();
        }

        if (!$gryffEditor.data('gryffeditor').isDragging()) {
          // Product List detect child change 2
          // Article List detect child change 2
          HELPER.flagListItemChange($element, 'design-options');

          if (HELPER.isInsideTheList($targetElement)) {
            const $itemContent = $targetElement.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          }
        }

        const $target = jQuery(e.target);
        if (!$target.is($that)) {
          $gfInputField.find('input').blur();
        }

        $gryffEditor.data('gryffeditor').setDragging(false);
      });
    };

    this.initMouseMoveEvent = function (data) {
      $gfLeftSideBar.css('cursor', 'ns-resize').on('mousemove.mp', function (e) {
        const { locate, $element, $targetElement } = data;
        const { $that, direction, old, start } = locate;
        const end = e.pageY;
        const _scrol = Math.floor(start - end);
        let newVar = old + Math.floor(start - end);

        if (_scrol > 20 || _scrol < -20) {
          if (
            $targetElement.hasClass('gf_row') &&
            ($element.attr('name') == 'margin-left' || $element.attr('name') == 'margin-right')
          ) {
            newVar = 'auto';
          }
          if ($element.hasClass('gf_padding') && newVar < 0) {
            newVar = '0';
          }

          $that.val(newVar);
          if (
            $targetElement.hasClass('gf_row') &&
            ($element.attr('name') == 'margin-left' || $element.attr('name') == 'margin-right')
          ) {
            var value = newVar;
          } else {
            var value = newVar + 'px';
          }

          $element.attr('value', value).trigger('input-change').trigger('value-change');
          // Remove px
          $element
            .parent()
            .find('input.gf_remove-spin-button')
            .attr('value', _this.removePx(value))
            .val(_this.removePx(value));
          // padding
          if ($element.hasClass('gf_padding') && $targetElement.data('gfoutline') != undefined) {
            $targetElement.data('gfoutline').updatePadding(direction, value, true);
          } else if ($element.hasClass('gf_margin') && $targetElement.data('gfoutline') != undefined) {
            $targetElement.data('gfoutline').updateMargin(direction, value, true);
          }
        }
      });
    };

    this.getTargetElement = function () {
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      return $gryffBody.find('#' + merId);
    };

    this.showMDSettingsPanel = function (type, mdSettings, id, panel, status) {
      let dataKey = null;

      const index = $sidePanels.find('#md-settings').index();
      _this.gotoTab(index);

      const $mdSettings = $gfLeftSideBar.find('#md-settings');

      $mdSettings.attr('data-editting', type).data('edittingID', id).html(mdSettings);

      $mdSettings.removeAttr('data-status');
      if (status == 'default' || status == 'dynamic') {
        $mdSettings.attr('data-status', 'dynamic');
      }

      let $panel;
      if (panel != undefined) {
        $panel = $gfLeftSideBar.find('#' + panel);
      } else {
        $panel = $gfLeftSideBar.find('#md-settings');
      }

      // set module title
      if ($gryffBody.find('#' + id).data('gfmodule') != undefined) {
        const $module = $gryffBody.find('#' + id);
        const moduleIcon = $module.data('gfmodule').getModuleIcon();
        const moduleName = $module.data('gfmodule').getModuleName();
        const moduleKey = $module.data('gfmodule').getModuleKey();
        var $merTitle = $panel.find('.md-title .mer-title');
        $merTitle.attr('data-label', moduleName);
        $merTitle.attr('data-key', moduleKey);
        $merTitle.attr('data-id', id);
        $merTitle.attr('data-type', 'module');
        $merTitle.children('span').html(moduleName);
        $merTitle.children('i').replaceWith(moduleIcon);
        dataKey = moduleKey;
      }
      if ($gryffBody.find('#' + id).data('gfelement') != undefined) {
        const $element = $gryffBody.find('#' + id);
        const elementName = $element.data('gfelement').getElementName();
        const elementKey = $element.data('gfelement').getElementKey();
        var $merTitle = $panel.find('.md-title .mer-title');

        $merTitle.attr('data-label', elementName);
        $merTitle.attr('data-key', elementKey);
        $merTitle.attr('data-id', id);
        $merTitle.attr('data-type', 'element');
        dataKey = elementKey;
      }
      if ($gryffBody.find('#' + id).data('gfrow') != undefined) {
        const $row = $gryffBody.find('#' + id);
        const rowName = $row.data('gfrow').getRowName();
        const rowKey = $row.data('gfrow').getRowKey();
        var $merTitle = $panel.find('.md-title .mer-title');
        $merTitle.attr('data-label', rowName);
        $merTitle.attr('data-key', rowKey);
        $merTitle.attr('data-id', id);
        $merTitle.attr('data-type', 'row');
        dataKey = rowKey;
      }

      //UPDATE_ELEMENT_SETTING_ACTIVE
      app.$store.commit('sidebar/UPDATE_ELEMENT_SETTING_ACTIVE', dataKey);
      $panel
        .find('.md-title')
        .append(
          '<button class="back-to-snippets"><svg fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/></svg></button>',
        );
      $panel
        .find('.back-to-snippets')
        .off('click')
        .on('click', function () {
          //back to design
          const currentSettingTab = store.getValue(keyCurrentSettingTab);
          const currentSidebarTab = store.getValue(keyCurrentSidebarTab);
          if (currentSidebarTab == 1 && currentSettingTab > 1) {
            const $gfTabs = $gfLeftSideBar.find('.simple-tabs');
            if ($gfTabs != undefined && $gfTabs.data('gftabs') != undefined) {
              $gfTabs.children('ul').show();

              $gfTabs.data('gftabs').gotoTab(1);
              return;
            }
          }

          _this.gotoTab(0);

          // Add to gfCount
          const extraCount = {};
          if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
            $gryffEditor.data('gfcount').add('back-to-snippets-btn', extraCount);
          }

          return false;
        });

      return $panel;
    };

    this.showHighlighter = function (cssClass) {
      $element.append('<div class="gf_panel-highlight ' + cssClass + '"></div>');
      setTimeout(function () {
        $element.find('.gf_panel-highlight').remove();
      }, 1000);
    };

    this.showLoading = function ($loading) {
      $loading.gfLoader();
      $loading.data('gfloader').show();
      return false;
    };

    this.hideLoading = function ($loading) {
      $loading.data('gfloader').hide();
      $loading.remove();
      return false;
    };

    this.disableScroll = function () {
      $($gfLeftSideBar.find('.optiscroll-content')[1]).css({
        'padding-right': '8px',
        'overflow-y': 'hidden',
      });
    };

    this.enableScroll = function () {
      $($gfLeftSideBar.find('.optiscroll-content')[1]).css({
        'padding-right': '',
        'overflow-y': '',
      });
    };

    this.getElementsStore = function () {
      return elementsStore;
    };

    /**
     * Sắp xếp dựa vào thứ tự trả về của categories
     */
    this.setupCategoriesOrder = function () {
      const snippetCategories = store.getValue('__snippetCategories');
      if (snippetCategories) {
        let order = 0;
        for (let i = 0; i < snippetCategories.length; i++) {
          const name = snippetCategories[i].name;
          this.categoriesOrder[name] = order++;
        }
      }
    };
    this.getCategoryOrder = function (name) {
      return this.categoriesOrder[name] !== undefined ? this.categoriesOrder[name] : -1;
    };

    /**
     * Render elements to left sidebar
     * @param {Function} callback function
     */

    //TODO: DUKCY
    function renderElements(callback) {
      const $panel = $sidePanels.find('#md-snippets');
      let snippets = '',
        elements = '',
        modules = '',
        cats = '';

      setTimeout(function () {
        _this.applyEvents();

        // $element.find('#md-snippets > .md-body').addClass('optiscroll').optiscroll();
        const outside = true;
        $element.find('#md-snippets > .md-body').on('scrollstart', function (ev) {
          _this.onBackgroundIframe('leftSideBarBody', outside);
        });

        $element
          .find('#md-snippets > .md-body')
          .off('mouseup.scroll')
          .on('mouseup.scroll', function (ev) {
            _this.offBackgroundIframe('leftSideBarBody', outside);
          });
        $element.find('#md-snippets > .md-body').on('scrollstop', function (ev) {
          _this.offBackgroundIframe('leftSideBarBody', outside);
        });
      }, 10);
    }

    this.addMoreButton = function (pageType) {
      const $panel = $sidePanels.find('#md-snippets');

      const addmore =
        `<div class="snippet-wrap show" id="gfAddSnippetButton">` +
        `<div class="snippet snippet-addmore">` +
        `<div class="snippet-icon">${$vectors.add}</div>` +
        `<span class="snippet-label">Add Elements</span>` +
        `</div>` +
        `</div>`;

      $panel.find('.gf-other_elements').next().append(addmore);

      if (pageType == 'template-product') {
        $panel.find('.all-snippets .snippet[data-cat="Product"]').addClass('snippet_product');
      } else if (pageType == 'template-article') {
        $panel.find('.all-snippets .snippet[data-cat="Blog Article"]').addClass('snippet_article');
      }
    };

    /**
     * Function to store element to elements storage
     * @param {Element} element need to be stored
     */
    function storeElement(element) {
      if (
        element == undefined ||
        element.getAttribute == undefined ||
        element.getAttribute('data-label') == undefined
      ) {
        return false;
      }

      const cat = element.getAttribute('data-cat') ? element.getAttribute('data-cat') : 'Element';
      const elementAssign = element.outerHTML;

      if (elementsStore.hasOwnProperty(cat)) {
        for (let i = 0; i < elementsStore[cat].length; i++)
          if (getDataKeyByElement(elementsStore[cat][i]) == element.getAttribute('data-key')) {
            elementsStore[cat][i] = elementAssign;
            return true;
          }
        elementsStore[cat].push(elementAssign);
      } else {
        elementsStore[cat] = [elementAssign];
      }
      return true;
    }

    function getDataKeyByElement(item) {
      return jQuery(item).attr('data-key');
    }

    /**
     * Remove an element from store
     * @param {Number} id of element need to remove
     */
    function removeElement(key) {
      for (const cat in elementsStore) {
        for (let i = 0; i < elementsStore[cat].length; i++) {
          if (getDataKeyByElement(elementsStore[cat][i]) == key.trim()) {
            elementsStore[cat].splice(i, 1);
            return true;
          }
        }
      }
      return false;
    }

    this.incSnippetUsage = function (snippetId = '', snippetKey = '') {
      if (!snippetId) {
        return;
      }
      if (!_this.snippetUsage[snippetId]) {
        _this.snippetUsage[snippetId] = {
          id: snippetId,
          key: snippetKey,
          usage: 1,
        };
      } else {
        _this.snippetUsage[snippetId].usage++;
      }
    };

    this.getSnippetUsageLocalStorage = function () {
      let storeSnippetUsage = localStorage.getItem('gfSnippetUsage');
      try {
        storeSnippetUsage = storeSnippetUsage ? JSON.parse(storeSnippetUsage) : {};
      } catch (error) {
        storeSnippetUsage = {};
      }
      return storeSnippetUsage;
    };

    this.resetSnippetUsage = function () {
      localStorage.removeItem('gfSnippetUsage');
    };

    this.saveSnippetsData = function (value) {
      const $that = jQuery(value);
      const templateId = HELPER.MakeId();
      $that.find('.template').attr('id', templateId);

      const label = $that.data('label') ? $that.data('label') : 'Unknown';
      const type = $that.data('type');
      const id = $that.data('id');
      const key = $that.data('key');
      const icon = $that.data('icon') ? $that.data('icon') : 'eicon-shortcode';
      const desc = $that.data('description') ? $that.data('description') : 'Place content elements inside the row';
      const form = $that.data('form') ? ' data-form="' + $that.data('form') + '" ' : '';
      const status = $that.attr('data-status');
      let textStt = '';
      let customStyle = '';
      switch (status) {
        case 'beta':
          textStt = ' isBeta';
          break;
        case 'test':
          textStt = /*" isTest"*/ ' isNew isHide';
          break;
        case 'hide':
          textStt = ' isHide';
          customStyle = `style="display: none;"`;
          break;
        case 'new':
          textStt = ' isNew';
          break;
        case 'invisible':
          customStyle = `style="display: none;"`;
          break;
      }

      const ver = $that.data('ver') ? $that.data('ver') : '1';
      const html = $that.html();
      const cat = 'module';

      const payload =
        `<div class="snippet${textStt}" data-id="${id}" data-key="${key}" data-ver="${ver}" data-cat="${
          cat == 'Other_Elements' ? $that.data('cat') : cat
        }" data-type="${type}" data-label="${label}" data-icon="${icon}" ${form}">` +
        `<div class="snippet-info" title="View Information" data-position="bottom">${$vectors.info}</div>` +
        `<div class="snippet-icon"><i class="${icon}"></i></div>` +
        `<span class="snippet-label">${
          label.indexOf(')') != -1
            ? '<span style="font-family:sans-serif">' +
              label.slice(0, label.indexOf(')') + 1) +
              '</span>' +
              label.slice(label.indexOf(')') + 1)
            : label.replace('Collection', '<span style="font-family:sans-serif">(C)</span>')
        }</span>` + // For backward compatibility
        `${`<span class="snippet-desc">${desc}</span>` + html}` +
        ` </div>`;

      app.$store.commit('editor/SET_DATA_SNIPPETS', {
        key: key,
        value: payload,
      });
    };

    this.saveSnippetUsageLocalStorage = function () {
      const storeSnippetUsage = _this.getSnippetUsageLocalStorage();
      const snippetUsage = _this.snippetUsage;
      _this.snippetUsage = {};

      for (const key in snippetUsage) {
        if (storeSnippetUsage[snippetUsage[key].id]) {
          storeSnippetUsage[snippetUsage[key].id].usage += snippetUsage[key].usage;
        } else {
          storeSnippetUsage[snippetUsage[key].id] = snippetUsage[key];
        }
      }

      localStorage.setItem('gfSnippetUsage', JSON.stringify(storeSnippetUsage));
    };

    this.createButtonCookie = function () {
      if ($gfLeftSideBar.closest('body').find('.cky-banner-element').length == 0) {
        $gfLeftSideBar.closest('body').append(`<button type="button" class="cky-banner-element"></button>`);
      }
      return;
    };

    this.removePx = function (value) {
      let newValue = value;
      if (newValue && newValue.includes('px')) {
        newValue = newValue.replace('px', '');
      }
      return newValue;
    };

    this.init();
  };
  jQuery.fn.gfLeftSideBar = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfleftsidebar')) {
        const plugin = new jQuery.gfLeftSideBar(this, options);
        jQuery(this).data('gfleftsidebar', plugin);
      }
    });
  };
})(jQuery);
